var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconsGuestSingle(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    stroke: "#FFF",
    strokeOpacity: 0.01,
    strokeWidth: 0.01,
    d: "M0 0h24v24H0V0z",
    transform: "translate(-351 -1366) translate(0 1161) translate(341 193) translate(10 12)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0F1015",
    d: "M13.976 8c.024-1.5-.895-2-2-2-1.104 0-1.976.5-2 2-.024 1.5.896 2 2 2 1.105 0 1.976-.5 2-2zm-6 0c.024-3 1.791-4 4-4 2.21 0 4.024 1 4 4-.024 3-1.79 4-4 4-2.209 0-4.024-1-4-4zM8 21l1.177-4.847c.316-1.16.616-1.153 1.82-1.153h2.006c1.2 0 1.506 0 1.82 1.153L16 21h2l-1.247-5.373C16.201 13.603 15.105 13 13.003 13h-2.006c-2.106 0-3.196.596-3.75 2.627L6 21h2z",
    transform: "translate(-351 -1366) translate(0 1161) translate(341 193) translate(10 12)"
  }))))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsGuestSingle);
export default __webpack_public_path__ + "static/media/icons-guest-single.76ea5b874b90c6e684caeed5c222aadf.svg";
export { ForwardRef as ReactComponent };